module.exports = __webpack_public_path__ + "static/img/7areaB_07.43bc49a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/7areaB_07.png
// module id = 1219
// module chunks = 1